// extracted by mini-css-extract-plugin
module.exports = {"container":"team-module--container--1h9zp","profile":"team-module--profile--3-0s1","nombre":"team-module--nombre--wB_o3","posicion":"team-module--posicion--AhBG3"};